import { ticks as d3Ticks } from 'd3-array';

import './styles/graphic.scss';

export default function (props, container) {
  const {
    chartData,
    y,
    yAxis,
    height,
    x,
    xAxis,
    width,
    margins,
    isMobile,
  } = props;

  const svgWidth = width + margins.left + margins.right;

  container.style('position', 'relative');

  const [yMin, yMax] = y.domain();
  const tickValues = d3Ticks(yMin, yMax, isMobile ? 3 : 5);
  const svgHeight = height + margins.top + margins.bottom;

  const svg = container.append('svg')
    .attr('width', svgWidth)
    .attr('height', svgHeight)
    .attr('aria-label', 'Significant earthquakes by year');

  const g = svg.append('g')
    .attr('transform', `translate(${margins.left}, ${margins.top})`);

  // y gridlines
  const yGridG = g.append('g')
    .attr('class', 'y grid')
    .call(
      yAxis(y)
        .tickValues(tickValues)
        .tickSize(-width)
        .tickFormat(d => d),
    );

  yGridG.selectAll('text')
    .attr('x', -5)
    .attr('text-anchor', 'end');

  yGridG.selectAll('.tick')
    .filter(d => d === 0)
    .select('line')
    .style('stroke', '#6e6e6e')
    .style('stroke-width', '0.5px');

  // x axis
  const tickYears = chartData
    .filter(d => Number(d.year) % 10 === 0)
    .map(d => d.year);

  g.append('g')
    .attr('class', 'x grid')
    .attr('transform', `translate(0, ${height})`)
    .call(xAxis(x).tickValues(tickYears));

  const bars = g.append('g')
    .attr('class', 'bars')
    .selectAll('rect')
    .data(chartData)
    .enter()
    .append('rect')
    .attr('x', d => x(d.year))
    .attr('y', d => y(d.count))
    .attr('width', x.bandwidth())
    .attr('height', d => height - y(d.count))
    .attr('class', d => (d.year === '2026' ? 'current-year' : null));

  bars.append('title')
    .text(d => `${d.year}: ${d.count} earthquakes`);
}
